import { Box, Link, Stack, Text } from '@chakra-ui/react';
import { IExemptions } from '../../../services/hooks/CandidateArea/useRequestMyExemption';

interface Props {
  exemptions: IExemptions[];
}

const RegistrationExemptionsSummary: React.FC<Props> = ({ exemptions }) => {
  if (exemptions.length === 0) return null;

  return (
    <Stack spacing={3} minW={0}>
      <Text fontSize="sm" fontWeight="bold">
        DADOS DA ISENÇÃO
      </Text>
      {exemptions.map((exemption) => (
        <Box key={exemption.id} minW={0}>
          <Text fontSize="sm">
            <strong>Tipo:</strong> {exemption.type}
          </Text>
          <Text fontSize="sm">
            <strong>Situação:</strong> {exemption.status}
          </Text>
          {exemption.subtype && (
            <Text fontSize="sm">
              <strong>Subtipo:</strong>{' '}
              {typeof exemption.subtype === 'string' ? exemption.subtype : exemption.subtype.name}
            </Text>
          )}
          {exemption.detail && (
            <Text fontSize="sm" overflowWrap="anywhere">
              <strong>Detalhes:</strong> {exemption.detail}
            </Text>
          )}
          {exemption.attachments?.length > 0 && (
            <Stack spacing={1} mt={1}>
              <Text fontSize="sm" fontWeight="semibold">
                Documentos enviados:
              </Text>
              {exemption.attachments.map((attachment) => (
                <Link
                  key={attachment.id}
                  href={attachment.file}
                  isExternal
                  color="blue.600"
                  fontSize="sm"
                  overflowWrap="anywhere"
                >
                  {attachment.name}
                  {attachment.description ? ` — ${attachment.description}` : ''}
                </Link>
              ))}
            </Stack>
          )}
        </Box>
      ))}
    </Stack>
  );
};

export default RegistrationExemptionsSummary;
